import { render, staticRenderFns } from "./athletes-photo.vue?vue&type=template&id=2cfab3dd&scoped=true&"
import script from "./athletes-photo.vue?vue&type=script&lang=js&"
export * from "./athletes-photo.vue?vue&type=script&lang=js&"
import style0 from "./athletes-photo.vue?vue&type=style&index=0&id=2cfab3dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfab3dd",
  null
  
)

export default component.exports